import blockchainAndWeb3Icon from '../../../public/svg/icons/rustIndustriesWeServe/blockchainAndWeb3.svg';
import financialServicesIcon from '../../../public/svg/icons/rustIndustriesWeServe/financialServices.svg';
import gamingEntertainmentIcon from '../../../public/svg/icons/rustIndustriesWeServe/gamingAndEntertainment.svg';
import iotAndEdgeComputingIcon from '../../../public/svg/icons/rustIndustriesWeServe/iotAndEdgeComputing.svg';
import saasPlatformsIcon from '../../../public/svg/icons/rustIndustriesWeServe/saasPlatforms.svg';
import type { IndustryData } from './IndustriesWeServe.types';

export const industriesWeServeData: IndustryData[] = [
  {
    title: 'Blockchain & Web3',
    description:
      'Build secure, high-performance blockchain nodes, smart contract platforms, and decentralized applications. Rust is the language of choice for projects like Solana, Polkadot, and Sui.',
    img: blockchainAndWeb3Icon,
  },
  {
    title: 'Financial Services',
    description: `Trading platforms, payment processors, and risk management systems benefit from Rust's combination of speed and safety. When milliseconds cost money, Rust delivers.`,
    img: financialServicesIcon,
  },
  {
    title: 'IoT & Edge Computing',
    description: `Process sensor data, manage device fleets, and run ML inference at the edge. Rust's small binary sizes and low resource usage make it perfect for constrained environments.`,
    img: iotAndEdgeComputingIcon,
  },
  {
    title: 'Gaming & Entertainment',
    description: `Game servers, matchmaking systems, and real-time multiplayer backends need to handle thousands of concurrent players. Rust's async capabilities and performance make it ideal.`,
    img: gamingEntertainmentIcon,
  },
  {
    title: 'SaaS Platforms',
    description: `Build scalable backend services that grow with your user base. From startup MVP to enterprise scale, Rust handles the entire journey without requiring a rewrite.`,
    img: saasPlatformsIcon,
  },
];
